module.exports = __webpack_public_path__ + "img/border_Ring.2b45772d.svg";